import React from "react";
import { CheckIcon } from "lucide-react";
import { volumes } from "../../data/content";
import { SectionCTA } from "../SectionCTA";
export function Volumes() {
  return <section className="bg-white px-4 py-16 md:py-24" data-id="element-301" data-mp="2x19vuhia6gbm">
      <div className="mx-auto max-w-4xl" data-id="element-302" data-mp="2wzp0ipo56tcp">
        <h2 className="text-center font-serif text-[30px] font-extrabold leading-tight text-navy md:text-5xl" data-id="element-303" data-mp="2szolp3x4sg54">
          What you'll find <em className="italic text-brand" data-id="element-304" data-mp="2o0v6n7274h2u">inside</em> the Playbook™
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-center text-[17px] text-ink-muted md:text-lg" data-id="element-305" data-mp="2ja52ty9f4ma9">
          6 practical volumes. Each one closes a specific stage of the planning process — in the order you actually make the decisions.
        </p>

        <ol className="mt-12 space-y-5" data-id="element-306" data-mp="29da5vjssmty3">
          {volumes.map(v => <li key={v.numeral} className="overflow-hidden rounded-3xl border border-navy/10 bg-canvas" data-id="element-307" data-mp="2592etfyv51wp">
              <div className="flex items-center gap-4 bg-navy px-5 py-4 md:px-8" data-id="element-308" data-mp="20c29j79u836n">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-gold font-serif text-xl font-black text-navy" data-id="element-309" data-mp="335e0tfvd1a9u">
                  {v.numeral}
                </span>
                <div className="min-w-0" data-id="element-310" data-mp="2u5qxupmzfweo">
                  <p className="text-xs font-bold uppercase tracking-wider text-brand-sky" data-id="element-311" data-mp="2u6sklrdd27c8">Volume {v.numeral}</p>
                  <h3 className="font-serif text-xl font-extrabold leading-tight text-white md:text-2xl" data-id="element-312" data-mp="2y4gh2yupc868">{v.title}</h3>
                </div>
              </div>
              <div className="p-5 md:p-8" data-id="element-313" data-mp="3qu5jngn28g9y">
                <p className="text-[17px] font-bold leading-snug text-navy" data-id="element-314" data-mp="3qsui7nh37km0">{v.subtitle}</p>
                <p className="mt-3 text-[16px] leading-relaxed text-ink-muted" data-id="element-315" data-mp="3cxjr8l5yrjmx">{v.body}</p>
                {v.bullets.length > 0 && <ul className="mt-4 grid grid-cols-1 gap-2 sm:grid-cols-2" data-id="element-316" data-mp="21fr15e2mxpmw">
                    {v.bullets.map(b => <li key={b} className="flex items-center gap-2 text-[15px] font-medium text-ink" data-id="element-317" data-mp="26g5086m9dp8s">
                        <CheckIcon className="h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-318" data-mp="bxtwypv2lf1u" />
                        {b}
                      </li>)}
                  </ul>}
              </div>
            </li>)}
        </ol>

        <SectionCTA label="Give Me All 6 Volumes" data-id="element-319" data-mp="3udnvmnbjb0li" />
      </div>
    </section>;
}